import { useContext, useEffect } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory, useParams } from 'react-router-dom';

import { useCurrency } from 'app/modules/CurrencyProvider';
import { PriceOptionType } from 'app/modules/PriceOptions/PriceOption';
import { translationQuoteApi } from 'app/modules/TranslationQuote/translationQuoteApi';
import { routes } from 'app/routes';
import { useHttpErrorAlert } from 'pkg/Alerts/useHttpErrorAlert';

import { UserContext } from '../Context';

export const usePriceOptions = () => {
  const { user, setUser } = useContext(UserContext);
  const { id } = useParams<{ id: string }>();
  const { currency } = useCurrency();
  const history = useHistory();
  const setHttpErrorAlert = useHttpErrorAlert();

  const { data: pricingWithInfo, isLoading: isLoadingPricing } = useQuery(
    [translationQuoteApi.queryKey, id, currency],
    translationQuoteApi.getPricing
  );

  const { mutate: orderNow, isLoading: isLoadingOrder } = useMutation(translationQuoteApi.orderNow, {
    onSuccess: (_, { option, totalPrice }) =>
      history.push(`${routes.PAYMENT_FINALIZATION}/0/${id}/${totalPrice.toFixed(2)}/${currency}/${option}`),
    onError: setHttpErrorAlert,
  });

  const handleOrderNow = (option: PriceOptionType) => (totalPrice: number) =>
    orderNow({ option, quoteId: id, currency, totalPrice });

  const isLoading = isLoadingPricing || isLoadingOrder;

  useEffect(() => {
    if (!user && pricingWithInfo?.email) {
      setUser({ email: pricingWithInfo.email, name: '' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pricingWithInfo]);

  return {
    pricing: pricingWithInfo?.options,
    phone: pricingWithInfo?.phone,
    handleOrderNow,
    isLoading,
    currency,
    canUpdate: pricingWithInfo?.canUpdate,
  };
};
